module.exports = __webpack_public_path__ + "assets-cabinet/img/cvv-card-icon.bd59b31a.svg";